import mapping from '~/utils/mapping.json';
import api from '~/state/api/index.js';
import ui from '~/state/ducks/ui/actions.js';


export const transform = (providers = []) => providers.map(({ id, type_id, name }) => ({
    id,
    name,
    type: mapping.sso_types.by_id[type_id],
}));

export const fetchSSOProviders = orgID => async (dispatch) => {
    try {
        const { data } = await dispatch(api.get('/sso/providers', {
            params: {
                portals: orgID,
                product_ids: Object.keys(mapping.license.by_id),
            },
        }));

        return transform(data);

    } catch (error) {
        dispatch(ui.flash.error({ header: 'Failed to fetch sso data' }, error));
    }
};
